module.exports = __webpack_public_path__ + "img/300.5f1fdd31.svg";